<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-12">
            <mat-card>
                <form #f="ngForm" [formGroup]="prescriptionForm" (ngSubmit)="savePrescription()">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="heading" *ngIf="!id">Add Prescription Template</h2>
                            <h2 class="heading" *ngIf="id">Edit Prescription Template</h2>
                        </div>

                        <div class="inputarea">
                            <!-- Treatment -->
                            <div class="col-12 input-container">
                                <input class="inputbox bold-placeholder" formControlName="treatment" placeholder="Treatment">
                                <span class="material-icons">medical_services</span>
                                <div *ngIf="prescriptionForm.get('treatment')?.invalid && 
                                           (prescriptionForm.get('treatment')?.dirty || 
                                            prescriptionForm.get('treatment')?.touched)" 
                                     class="erro1">
                                    Treatment is Required
                                </div>
                            </div>

                            <!-- Department Dropdown -->
                            <div class="col-12 input-container">
                                <select class="inputbox" formControlName="department_id" required>
                                    <option [ngValue]="null" disabled selected>Select Department</option>
                                    <option *ngFor="let department of departments" [value]="department._id">
                                        {{ department.name }}
                                    </option>
                                </select>
                                <span class="material-icons">category</span>
                                <div *ngIf="prescriptionForm.get('department_id')?.invalid && 
                                           (prescriptionForm.get('department_id')?.dirty || 
                                            prescriptionForm.get('department_id')?.touched)" 
                                     class="erro1">
                                    Department is Required
                                </div>
                            </div>

                            <!-- Treatment Notes -->
                            <div class="col-12">
                                <h4 class="bold-text">Treatment Notes</h4>
                                <div formArrayName="treatmentNotes">
                                    <div *ngFor="let note of treatmentNotes.controls; let i = index" class="d-flex !mb-3 input-container">
                                        <input class="inputbox" [formControlName]="i" placeholder="Treatment Note">
                                        <button (click)="removeTreatmentNote(i)" class="delete-btn" type="button">
                                            <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    </div>
                                </div>
                                <button type="button" (click)="addTreatmentNote()" class="add-btn">
                                    <span class="material-icons">add</span> Add Note
                                </button>
                            </div>

                            <!-- Symptoms -->
                            <div class="col-12">
                                <h4 class="bold-text">Symptoms</h4>
                                <div formArrayName="symptoms">
                                    <div *ngFor="let symptom of symptoms.controls; let i = index" class="d-flex !mb-3 input-container">
                                        <input class="inputbox" [formControlName]="i" placeholder="Symptom">
                                        <button (click)="removeSymptom(i)" class="delete-btn" type="button">
                                             <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    </div>
                                </div>
                                <button type="button" (click)="addSymptom()" class="add-btn">
                                    <span class="material-icons">add</span> Add Symptom
                                </button>
                            </div>

                            <!-- Tests -->
                            <div class="col-12">
                                <h4 class="bold-text">Tests</h4>
                                <div formArrayName="tests">
                                    <div *ngFor="let test of tests.controls; let i = index" class="d-flex !mb-3 input-container">
                                        <input class="inputbox" [formControlName]="i" placeholder="Test">
                                        <button (click)="removeTest(i)" class="delete-btn" type="button">
                                             <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    </div>
                                </div>
                                <button type="button" (click)="addTest()" class="add-btn">
                                    <span class="material-icons">add</span> Add Test
                                </button>
                            </div>

                            <!-- Prescribed Drugs -->
                            <div class="col-12">
                                <h4 class="bold-text">Prescribed Drugs</h4>
                                <div formArrayName="prescribed_drugs">
                                    <div *ngFor="let drug of prescribedDrugs.controls; let i = index" class="drug-section">
                                        <div class="drug-header">
                                            <h5>Drug #{{i+1}}</h5>
                                            <button (click)="removeDrug(i)" class="delete-btn" type="button">
                                                 <span class="material-symbols-outlined">delete</span>
                                            </button>
                                        </div>
                                        
                                        <div class="drug-fields" [formGroupName]="i">
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="name" placeholder="Drug Name">
                                                <span class="material-icons">medication</span>
                                                <div *ngIf="drug.get('name')?.invalid && 
                                                           (drug.get('name')?.dirty || 
                                                            drug.get('name')?.touched)" 
                                                     class="erro1">
                                                    Drug Name is Required
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="dosage" placeholder="Dosage">
                                                <span class="material-icons">exposure</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="quantity" placeholder="Quantity">
                                                <span class="material-icons">format_list_numbered</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="duration" placeholder="Duration">
                                                <span class="material-icons">schedule</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="repeat" placeholder="Repeat">
                                                <span class="material-icons">repeat</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="timeoftheday" placeholder="Time of the day">
                                                <span class="material-icons">access_time</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="tobeTaken" placeholder="To be taken">
                                                <span class="material-icons">restaurant</span>
                                            </div>
                                            <div class="col-12">
                                                <input class="inputbox" formControlName="type" placeholder="Type (Tablet/Syrup/etc)">
                                                <span class="material-icons">local_pharmacy</span>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="inputbox" formControlName="remark" placeholder="Remark" rows="2"></textarea>
                                                <span class="material-icons">notes</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" (click)="addDrug()" class="add-btn">
                                    <span class="material-icons">add</span> Add Drug
                                </button>
                            </div>

                            <!-- Submit Button -->
                            <div class="col-12">
                                <button type="submit" [disabled]="prescriptionForm.invalid || isFormLoading" class="submit">
                                    {{id ? 'Update' : 'Submit'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
</div>